<nav class="wizard-steps" [class.wizard-steps--bars]="variant() === 'bars'">
  <ol class="wizard-steps__list">
    @for (label of steps(); track $index; let i = $index) {
      <li class="wizard-steps__item">
        <button
          type="button"
          class="wizard-steps__step"
          [class.wizard-steps__step--active]="i === current() && !completed()"
          [class.wizard-steps__step--done]="isDone(i)"
          [class.wizard-steps__step--editing]="isEditing(i)"
          [class.wizard-steps__step--pending]="isPending(i)"
          [disabled]="isDisabled(i)"
          [attr.aria-current]="i === current() && !completed() ? 'step' : null"
          (click)="onStepClick(i)"
        >
          @if (variant() === 'bars') {
            <span class="wizard-steps__step-bar" aria-hidden="true">
              <span class="wizard-steps__step-bar-fill"></span>
            </span>
            <span class="wizard-steps__label">
              @if (isEditing(i)) {
                <img
                  class="wizard-steps__edit-icon"
                  src="./assets/img/pencil-icon.svg"
                  alt=""
                  draggable="false"
                />
              }
              @if (isDone(i)) {
                <img
                  class="wizard-steps__done-icon"
                  src="./assets/img/ic-check-green-new.svg"
                  alt=""
                  draggable="false"
                />
              }
              {{ label | translate }}
            </span>
          } @else {
            <span class="wizard-steps__number">
              @if (isDone(i)) {
                <img draggable="false" src="./assets/img/ic-check-gunmetal.svg" alt="" />
              } @else {
                {{ i + 1 }}
              }
            </span>
            <span class="wizard-steps__label">{{ label | translate }}</span>
          }
        </button>
      </li>
    }
  </ol>

  <div class="wizard-steps__mobile">
    <div class="wizard-steps__mobile-label">
      @if (completed() && completedLabel()) {
        <b>{{ completedLabel() | translate }}</b>
      } @else {
        {{ 'WizardSteps.mobileLabel' | translate: { current: current() + 1, total: steps().length } }}
        · <b>{{ steps()[current()] | translate }}</b>
        @if (editing()) {
          <span class="wizard-steps__mobile-editing">{{ 'WizardSteps.editing' | translate }}</span>
        }
      }
    </div>
    <div class="wizard-steps__bar">
      <span class="wizard-steps__bar-fill" [style.width.%]="progress()"></span>
    </div>
  </div>
</nav>
